import { createSelector } from 'reselect';

const selectUsers = (state: any) => state.users;


export const selectUsersCurrentItem = createSelector([selectUsers], (users) => users.current);

export const selectUsersListItems = createSelector([selectUsers], (users) => users.list);

export const selectUsersItemById = (itemId: any) =>
    createSelector(selectUsersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectUsersQueryItems = createSelector([selectUsers], (users) => users.query);

export const selectUsersCreatedItem = createSelector([selectUsers], (users) => users.create);

export const selectUsersUpdatedItem = createSelector([selectUsers], (users) => users.update);

export const selectUsersReadItem = createSelector([selectUsers], (users) => users.read);

export const selectUsersDeletedItem = createSelector([selectUsers], (users) => users.delete);

export const selectUsersSearchedItems = createSelector([selectUsers], (users) => users.search);

export const selectUsersItemsCount = createSelector([selectUsers], (users) => users.count);

export const selectUsersItemsFilter = createSelector([selectUsers], (users) => users.filter);